import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/Appointments/";

export function createAppointment(params) {
  params = { ...params, portalID: 3 };
  return apiUtils
    .post(`${baseUrl}NewAppointment`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function confirmationEmail(params) {
  return apiUtils
    .post(
      `${baseUrl}ConfirmationEmail?AppointmentID=${params.AppointmentID}&LocationID=${params.LocationID}&BrandIdentifier=${params.BrandIdentifier}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getLocationsWithinRadius(
  lat,
  lng,
  radius,
  dType,
  test,
  brandIdentifier,
  clientId,
) {
  return apiUtils
    .get(
      `${baseUrl}GetInstallLocations?lat=${lat}&lng=${lng}&radius=${radius}&devicetype=${dType}&IsTest=${test}&brandIdentifier=${brandIdentifier}&clientId=${clientId}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getAvailableDates(
  clientID,
  vehicleId,
  locationID,
  deviceType,
  appointmentType,
  appointmentDate,
) {
  return apiUtils
    .get(
      `${baseUrl}GetAvailableDates/?ClientID=${clientID}&VehicleId=${vehicleId}&Locationid=${locationID}&deviceType=${deviceType}&appointmenttype=${appointmentType}&appointmentdate=${appointmentDate}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getAvailableTimes(
  clientID,
  locationID,
  deviceType,
  appointmentType,
  date,
) {
  return apiUtils
    .get(
      `${baseUrl}GetAvailableTimes/?ClientID=${clientID}&Locationid=${locationID}&devicetype=${deviceType}&appointmenttype=${appointmentType}&appointmentdate=${date}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getAppointments(clientId) {
  return apiUtils
    .get(`${baseUrl}${clientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getLocation(locationID) {
  return apiUtils
    .get(`${baseUrl}GetLocation?locationID=${locationID}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
